import { useContext, useEffect, useState } from 'react';
import { Button, Col, Collapse, Form, Row, Select, Skeleton } from 'antd';
import DashboardContext from 'Context';
import axios from 'axios';

export default function NewSpecialitiesCollapse({ setValue }) {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [accordions, setAccordions] = useState([]);
    const [accordionValues, setAccordionValues] = useState([]);
    const { authentication, urldashboard } = useContext(DashboardContext);

    useEffect(() => {
        getSpecialities();
    }, []);

    const getSpecialities = async () => {
        try {
            setLoading(true);
            let url = '/worker/specificationvaluedropdown';
            const res = await axios.get(urldashboard + url, {
                headers: {
                    Authorization: authentication,
                    'Content-Type': 'application/json',
                },
                params: {},
            });
            const data = await res?.data?.data;
            setAccordions(data);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setAccordions([]);
        }
    };

    const handleDeselect = (value) => {
        const index = accordionValues?.indexOf(value);
        if (index > -1) {
            accordionValues?.splice(index, 1);
        }
        setAccordionValues(accordionValues);
    };

    const handleSelect = (value) => {
        setAccordionValues([value, ...accordionValues]);
    };

    return (
        <>
            <Collapse accordion>
                {loading ? <Skeleton /> : <>
                    {accordions?.length > 0 &&
                        accordions?.map((item, index) => (
                            <Collapse.Panel key={index} header={item?.title}>
                                <Form
                                    form={form}
                                    layout='vertical'
                                >
                                    <Row gutter={20}>
                                        {item?.specificationValues?.length > 0 &&
                                            item?.specificationValues?.map((ddItem, ddIndex) => (
                                                <Col
                                                    xl={12}
                                                    lg={12}
                                                    md={12}
                                                    sm={24}
                                                    xs={24}
                                                    key={ddIndex}
                                                >
                                                    <Form.Item label={ddItem?.dropDownName}>
                                                        <Select
                                                            direction={'rtl'}
                                                            allowClear
                                                            mode='multiple'
                                                            defaultValue={ddItem?.dropDownValues?.filter(
                                                                (item) =>
                                                                    accordionValues?.includes(item.value)
                                                            )}
                                                            onSelect={handleSelect}
                                                            onDeselect={handleDeselect}
                                                        >
                                                            {ddItem?.dropDownValues?.map((option) => (
                                                                <Select.Option
                                                                    key={option.value}
                                                                    label={option.value}
                                                                >
                                                                    {option.label}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            ))}
                                    </Row>
                                </Form>
                            </Collapse.Panel>
                        ))}
                </>}
            </Collapse>
            <Row justify={'end'} gutter={10} style={{ marginTop: '1rem' }}>
                <Col span={4}>
                    <Button
                        type='default'
                        style={{ width: '100%' }}
                        onClick={() => {
                            setAccordionValues([]);
                            setValue([]);
                        }}
                    >
                        پاک کردن فرم
                    </Button>
                </Col>
                <Col span={4}>
                    <Button
                        type='primary'
                        style={{ width: '100%' }}
                        onClick={() => setValue(accordionValues)}
                    >
                        جستجو
                    </Button>
                </Col>
            </Row>
        </>
    );
}
